module.exports = __webpack_public_path__ + "static/00017.836a655a.jpg";